import type { RippleDesignTokens } from '@primeuix/themes/types/ripple'

export default {
    colorScheme: {
        dark: {
            root: {
                background: 'rgba(255,255,255,0.3)',
            },
        },
        light: {
            root: {
                background: 'rgba(0,0,0,0.1)',
            },
        },
    },
} satisfies RippleDesignTokens
